import { Select, type SelectProps } from 'antd';
import { type BaseOptionType, type DefaultOptionType } from 'antd/es/select';
import styled, { css } from 'styled-components';

export const StyledSelectContainer = styled.div`
  display: flex;
  align-items: center;
  height: 30px;
`;

export const Label = styled.span<{ $backgroundColor?: string }>`
  color: rgb(0 0 0 / 85%);
  font-size: 14px;
  white-space: nowrap;
  height: 28px;
  border: 1px solid #d9d9d9;
  border-right: none;
  padding: 0 8px;
  background-color: ${({ $backgroundColor }) => $backgroundColor || '#F5F5F5'};
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
`;

export const ValueSelect = styled(Select)<
  SelectProps<any, BaseOptionType | DefaultOptionType> & {
    $showRightBorder?: boolean;
    $minWidth?: string;
  }
>`
  &.gm-ant-select {
    display: inline-flex;
    flex: 1;
    min-width: 0;
    height: 30px;

    .gm-ant-select-selector {
      width: fit-content !important;
      min-width: ${({ $minWidth }) => ($minWidth ? $minWidth : '120px')};
      flex-grow: 1;
      height: 30px;
      border: 1px solid #d9d9d9;
      border-radius: 0;
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;

      .gm-ant-select-selection-placeholder {
        color: rgb(0 0 0 / 25%);
      }

      .gm-ant-select-selection-overflow-item {
        max-width: calc(100% - 60px);
      }
    }

    &:hover .gm-ant-select-selector {
      border-color: #40a9ff;
    }

    &.gm-ant-select-focused .gm-ant-select-selector {
      border-color: #40a9ff;
      box-shadow: 0 0 0 2px rgb(24 144 255 / 20%);
    }
  }

  ${({ $showRightBorder = true }) => {
    if (!$showRightBorder) {
      return css`
        &:not(.gm-ant-select-focused, :hover) {
          .gm-ant-select-selector {
            border-right: 0;
          }
        }
      `;
    }
    return;
  }}

  &.gm-ant-select-disabled:hover {
    .gm-ant-select-selector {
      border-color: #d9d9d9;
    }
  }

  &.gm-ant-select-status-error {
    .gm-ant-select-selector {
      border-color: #ff7875 !important;
    }
  }
`;
